import fetchShowroomApi from "../utils/fetch-showroom-api";

customElements.component = 'add-to-showroom';

if(!customElements.get(customElements.component)) {
  const selectors = {
    button: ".js-add-to-showroom-btn",
    popup: ".js-add-to-showroom__popup",
    popupClose: ".js-add-to-showroom__close",
    form: ".js-add-to-showroom-form",
    inputs: ".js-add-to-showroom-form input",
    submit: ".js-add-to-showroom__submit",
    checkboxAll: ".js-add-to-showroom-checkbox-all",
    returnLink: ".js-add-to-showroom-return"
  }

  class AddToShowroom extends HTMLElement {
    constructor() {
      super();

      this.isCollectionOrProductPage = window.location.pathname.includes("/collections/") || window.location.pathname.includes("/products/");

      this.button = this.querySelector(selectors.button);
      this.popup = this.querySelector(selectors.popup);
      this.popupClose = this.querySelector(selectors.popupClose);
      this.form = this.querySelector(selectors.form);
      this.submit = this.querySelector(selectors.submit);
      this.returnLink = this.querySelector(selectors.returnLink);
      this.showroomId = window.localStorage.getItem("last_viewed_showroom");
      this.productHandle = this.button.getAttribute("data-product-handle");
      this.productColor = this.button.getAttribute("data-color-name");
      this.data = {}

      this.init();
    }

    async getData() {
      this.data = await fetchShowroomApi(`/showrooms/${this.showroomId}`);

      if (this.data.currentCustomerIsOwner && this.isCollectionOrProductPage) {
        this.classList.remove("hidden");
      }
    }

    render() {
      this.data.bridesmaids.forEach(obj => {
        this.form.innerHTML += `
          <label>
            <input type="checkbox" name="bridesmaid_id" value="${obj.id}" />
            <span>${obj.name || "Name"}</span>
          </label>
        `
      })

      this.returnLink.setAttribute("href", `/pages/showroom-select-dresses?id=${this.data.id}`);
    }

    destroy() {
      this.form.innerHTML = "";
    }

    handleOpen() {
      this.popup.classList.add("opened");
    }

    handleClose() {
      this.popup.classList.remove("opened");
    }

    async handleInputChange(input) {
      this.productColor = this.button.getAttribute("data-color-name");
      const bridesmaidId = input.value;
      const body = {
        "dressHandle": this.productHandle,
        "dressColor": this.productColor,
        "bridesmaidIds": [
          bridesmaidId
        ]
      }

      await fetchShowroomApi(`/showrooms/${this.data.id}/dresses`, input.checked ? "POST" : "DELETE", JSON.stringify(body));
    }

    handleAssignToAll(checked) {
      this.inputs = this.querySelectorAll(selectors.inputs);

      this.inputs.forEach(async input => {
        this.productColor = this.button.getAttribute("data-color-name");
        const bridesmaidId = input.value;

        const body = {
          "dressHandle": this.productHandle,
          "dressColor": this.productColor,
          "bridesmaidIds": [
            bridesmaidId
          ]
        }

        await fetchShowroomApi(`/showrooms/${this.data.id}/dresses`, checked ? "POST" : "DELETE", JSON.stringify(body));

        input.checked = checked;
      });
    }

    clearInputs() {
      this.inputs = this.querySelectorAll(selectors.inputs);

      this.inputs.forEach(input => input.checked = false)
    }

    setInputValue(input) {
      this.data.bridesmaids.forEach(bridesmaid => {
        if (bridesmaid.id === input.value && bridesmaid.bridesmaidsDresses) {
          bridesmaid.bridesmaidsDresses.forEach(dress => {
            if (dress.dressColor === this.productColor && dress.shopifyProductHandle === this.productHandle) {
              input.checked = true;
            }
          })
        }
      })
    }

    initEvents() {
      this.button && this.button.addEventListener("click", this.handleOpen.bind(this));
      this.popupClose && this.popupClose.addEventListener("click", this.handleClose.bind(this));
      this.submit && this.submit.addEventListener("click", this.handleClose.bind(this));

      this.inputs = this.querySelectorAll(selectors.inputs);

      this.inputs.forEach(input => {
        this.setInputValue(input);

        input.addEventListener("change", () => this.handleInputChange(input));
      });

      this.checkboxAll = this.querySelector(selectors.checkboxAll);

      this.checkboxAll && this.checkboxAll.addEventListener("change", e => this.handleAssignToAll(e.target.checked));

      const observer = new MutationObserver(async (mutationsList) => {
        for (let mutation of mutationsList) {
          if (mutation.type === "attributes" && mutation.attributeName === "data-color-name") {
            this.clearInputs();

            await this.getData();

            this.productColor = this.button.getAttribute("data-color-name");

            this.inputs.forEach(input => this.setInputValue(input));
          }
        }
      });

      observer.observe(this.button, {
        attributes: true
      });
    }

    async init() {
      await this.getData();

      if (this.data) {
        this.productColor = this.button.getAttribute("data-color-name");

        this.render();
        this.initEvents();
      } else {
        this.button.classList.add("hidden");
      }
    }
  }

  customElements.define(customElements.component, AddToShowroom);
}
